import styles from "./ua.module.scss";

export default function FieldLabel(props) {
  
  if (!props.for) {
    console.error("******* SEO WARNING! Label: NO \"for\" SPECIFIED!!!!", { children: props.children });
  }  

  return <label htmlFor={props.for} className={ styles.label}>{ props.children }</label>

}
